import {
  ComponentValidationError,
  ValidationError,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/component-validations/types';
import { getDisplayNameForStep } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenEditor/utils';
import { InquiryTemplateVersionStepUi } from 'dashboard/models/inquiry-template-version';
import { isUiTransitionComponentConfig, UiComponentConfig } from 'lib/interfaces/ui-components';

type ValidateTransitionComponentConfigProps = {
  componentConfig: UiComponentConfig;
  step: InquiryTemplateVersionStepUi;
};

const validateTransitionComponentConfig = ({
  componentConfig,
  step,
}: ValidateTransitionComponentConfigProps) => {
  if (!isUiTransitionComponentConfig(componentConfig)) return [];
  const errors: ComponentValidationError[] = [];
  if (
    componentConfig.config['to-step'] == null &&
    componentConfig.config['workflow-version-id'] == null
  ) {
    errors.push({
      type: ValidationError.TransitionInvalid,
      message: `Component in "${getDisplayNameForStep(
        step,
      )}" is missing either a step or action transition`,
      componentType: componentConfig.type,
      stepName: step.name,
    });
  }

  if (
    componentConfig.config['workflow-version-id'] != null &&
    componentConfig.config['workflow-on-error-step-name'] == null
  ) {
    errors.push({
      type: ValidationError.TransitionActionMissingErrorStep,
      message: `Component in "${getDisplayNameForStep(
        step,
      )}" is missing a corresponding error step for action transition`,
      componentType: componentConfig.type,
      stepName: step.name,
    });
  }

  return errors;
};

export default validateTransitionComponentConfig;
